import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const AB360Demo = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [liveTransferPhoneNumber, setLiveTransferPhoneNumber] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("us");
  const [country2, setCountry2] = useState("us");
  const [typeOfCall, setTypeOfCall] = useState("prod");
  const [leadType, setLeadType] = useState("ab360_smb_calling_out_of_the_blue");
  const [humanAgentCompanyName, setHumanAgentCompanyName] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const friendlyNames = {
      ab360_smb_calling_out_of_the_blue: "AB360 SMB Calling Out of the Blue",
      ab360_smb_can_you_help_me: "AB360 SMB Can You Help Me",
      ab360_smb_not_sure_open_to: "AB360 SMB Not Sure Open To",
      ab360_smb_quick_question: "AB360 SMB Quick Question",
      ab360_smb_safe_distance: "AB360 SMB Safe Distance",
      ab360_smb_uncertain_permission: "AB360 SMB Uncertain Permission",
      ab360_new_outreach_v3: "AB360 New Outreach V3",
      ab360_lead_reactivation_v1: "AB360 Lead Reactivation V1",
      ab360_alternate_outreach: "AB360 Alternate Outreach",
    };

    const fromNumber = "18508883579";
    const agentID = typeOfCall === "prod"
      ? "agent_30ce2134ef786f89151af8b879"
      : "agent_290e4ddd9c79c0205602020c4a";
    const baseUrl = "https://initiateretellcall-655075094783.us-central1.run.app";

    const human_agent_id = "0ho90QkFDmsLuKGZ4iAv";
    const lead_id = "FSHpnvJoxO7iFKP63BxF";
    const lead_first_name = userFirstName;
    const lead_state = state;
    const human_agent_company_name = humanAgentCompanyName;
    const human_agent_number = `+${liveTransferPhoneNumber}`;
    const lead_type = leadType;
    const lead_type_friendly_name = friendlyNames[lead_type] || lead_type;
    const lead_tz = "America/Chicago";
    const human_agent_tz = "America/New_York";
    const to_number = phoneNumber;

    const url = `${baseUrl}?lead_id=${lead_id}&lead_first_name=${lead_first_name}&from_number=${fromNumber}&agent_id=${agentID}&human_agent_id=${human_agent_id}&human_agent_company_name=${human_agent_company_name}&to_number=+${to_number}&lead_state=${lead_state}&human_agent_number=${human_agent_number}&human_agent_first_name=Marco&lead_type=${lead_type}&human_agent_tz=${human_agent_tz}&lead_tz=${lead_tz}&lead_type_friendly_name=${lead_type_friendly_name}`;

    console.log(`Starting call with URL ${url}`);

    await axios
      .request(url, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => window.alert("Call initiated successfully!"));
  };

  const getQueueOptions = () => {
    return [
      { value: "ab360_smb_calling_out_of_the_blue", label: "AB360 SMB Calling Out of the Blue" },
      { value: "ab360_smb_can_you_help_me", label: "AB360 SMB Can You Help Me" },
      { value: "ab360_smb_not_sure_open_to", label: "AB360 SMB Not Sure Open To" },
      { value: "ab360_smb_quick_question", label: "AB360 SMB Quick Question" },
      { value: "ab360_smb_safe_distance", label: "AB360 SMB Safe Distance" },
      { value: "ab360_smb_uncertain_permission", label: "AB360 SMB Uncertain Permission" },
      { value: "ab360_new_outreach_v3", label: "AB360 New Outreach V3" },
      { value: "ab360_lead_reactivation_v1", label: "AB360 Lead Reactivation V1" },
      { value: "ab360_alternate_outreach", label: "AB360 Alternate Outreach" },
    ];
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{
              color: '#FFFFFF',
              fontSize: '2rem',
              fontWeight: 'bold',
              margin: '1rem',
            }}>
              Agent Boost 360 DEMO
            </h1>
            <div style={{
              height: '4px',
              width: '100px',
              background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>
          <h3 style={{
            textAlign: 'center',
            color: '#d0d0d0',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '1.6',
            maxWidth: '500px',
            margin: '0 auto 1.5rem auto'
          }}>
            Receive a demonstration call from the selected script
          </h3>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>

              <>
                <Select
                  value={typeOfCall}
                  onChange={(e) => {
                    setTypeOfCall(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  <MenuItem value="prod">
                    Production Release
                  </MenuItem>
                  <MenuItem value="dev">
                    Development and Testing
                  </MenuItem>
                </Select>
                <Select
                  value={leadType}
                  onChange={(e) => {
                    setLeadType(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  {getQueueOptions().map((queue) => (
                    <MenuItem key={queue.value} value={queue.value}>
                      {queue.label}
                    </MenuItem>
                  ))}
                </Select>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    label="Lead First Name"
                    variant="filled"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    fullWidth
                    value={userFirstName}
                    onChange={(e) => setUserFirstName(e.target.value)}
                    required
                  />
                  <TextField
                    label="State"
                    variant="filled"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px"
                    }}
                    fullWidth
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    required
                  />
                </Stack>
                <TextField
                  label="Company Name"
                  variant="filled"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  value={humanAgentCompanyName}
                  onChange={(e) => setHumanAgentCompanyName(e.target.value)}
                  required
                />
              </>
              <h3 style={{
                color: '#FFFFFF',
                fontSize: '1rem',
                fontWeight: 'bold',
                margin: '16px 0 0 0',
                textAlign: 'left'
              }}>
                Your Number
              </h3>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                  <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                      height: "56px",
                    }}
                    required
                  >
                    <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                    <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                  <PhoneInput
                    country={country}
                    value={phoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setPhoneNumber}
                    enableLongNumbers={true}
                    placeholder="Enter your phone number"
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    required
                  />
                </Box>
              </Stack>
              <h3 style={{
                color: '#FFFFFF',
                fontSize: '1rem',
                fontWeight: 'bold',
                margin: '16px 0 0 0',
                textAlign: 'left'
              }}>
                Live Transfer Number
              </h3>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                  <Select
                    value={country2}
                    onChange={(e) => setCountry2(e.target.value)}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                      height: "56px",
                    }}
                    required
                  >
                    <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                    <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                  <PhoneInput
                    country={country2}
                    value={liveTransferPhoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setLiveTransferPhoneNumber}
                    enableLongNumbers={true}
                    placeholder="Enter live transfer phone number"
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    required
                  />
                </Box>
              </Stack>
              <Button
                className="callBtn"
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                  color: 'white',
                  height: '56px',
                  padding: '0 30px',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                    background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                  },
                }}
              >
                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Click here to receive the DEMO call
                </h2>
                <div style={{ width: "20px" }} />
                <Call className="callIcon" />
              </Button>
              <div style={{
                // Bubble Container Styles
                backgroundColor: '#eaf2fa',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d0e0f0',

                // Flexbox for alignment
                display: 'flex',
                alignItems: 'center', // Vertically centers the icon and text
                gap: '12px'           // Adds space between the icon and text
              }}>
                {/* Icon */}
                <span style={{ fontSize: '24px' }}>ℹ️</span>

                {/* Text Content */}
                <p style={{
                  margin: 0, // Resets default paragraph margin
                  textAlign: 'left',
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '14px'
                }}>
                  After clicking to receive the DEMO call, you will receive a call from the following number:
                  <b style={{ color: '#005a9c' }}> +1 (850) 888-3579</b>
                </p>
              </div>
            </Stack>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
